<template>
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="收银中心-收银记录"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box">
                <div class="item-search">
                    <el-date-picker
                            v-model="startDate"
                            type="date"
                            placeholder="选择开始日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;&nbsp;
                    <el-date-picker
                            v-model="endDate"
                            type="date"
                            placeholder="选择结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;&nbsp;
                    <el-select v-model="payValue" placeholder="请选择收款方式" clearable class="select">
                        <el-option label="所有付款方式" value=""></el-option>
                        <el-option
                                v-for="pay in payType"
                                :key="pay.value"
                                :label="pay.label"
                                :value="pay.value">
                        </el-option>
                    </el-select>&nbsp;&nbsp;
                    <el-select v-model="orderState" placeholder="请选择订单状态" clearable class="select">
                        <el-option label="所有订单" value=""></el-option>
                        <el-option
                                v-for="val in orderStateArr"
                                :key="val.value"
                                :label="val.label"
                                :value="val.value">
                        </el-option>
                    </el-select>&nbsp;&nbsp;
                    <el-select v-model="orderType" placeholder="请选择消费项目" clearable class="select">
                        <el-option label="所有项目" value=""></el-option>
                        <el-option
                                v-for="val in orderTypeArr"
                                :key="val.value"
                                :label="val.label"
                                :value="val.value">
                        </el-option>
                    </el-select>&nbsp;&nbsp;
                    <el-input v-model="searchOrderNo" placeholder="订单号" style="width: 150px" />&nbsp;&nbsp;
                    <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                    <el-button @click="voidEvent">作废</el-button>
                </div>
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <div class="table-content">
                        <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil" width="100%"
                                  header-cell-class-name="table-ceil" @current-change="handleSelectionChange"
                        >
                            <el-table-column label="" width="55">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.isChecked"
                                                 :disabled="scope.row.state === '6'"
                                                 @change="checkedClick(scope.row)"
                                    >&nbsp;</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pay_datetime" label="收银时间" width="180">
                                <template slot-scope="data">
                                    <p v-show="data.row.order_no">{{data.row.order_no}}</p>
                                    <p>{{data.row.pay_datetime}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="顾客" width="160">
                                <template slot-scope="data">
                                    <span v-if="data.row.store_uid">
                                        {{data.row.u_name}}
                                        <el-tag type="warning" v-if="data.row.vip_id">{{data.row.vip_name}}</el-tag>
                                    </span>
                                    <span v-else>散客</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="消费项目" width="200">
                                <template slot-scope="data">
                                    <div class="order-data">
                                        <p v-for="(val, key) in data.row.order_data" :key="'order_'.key">
                                            <span>{{val.title}} ¥{{val.total_price}}</span>
                                        </p>
                                        <p v-for="(val, key) in data.row.other_data" :key="'other_'.key">
                                            <span>{{val.title}}</span>
                                        </p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="total_price" label="消费价格"></el-table-column>
                            <el-table-column prop="actual_price" label="实收">
                                <template slot-scope="data">
                                    <span>{{data.row.actual_price}}</span>
                                    <span v-if="data.row.state == 6">
                                        &nbsp;&nbsp;<el-tag type="danger">已作废</el-tag>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pay_type_name" label="付款方式">
                                <template slot-scope="data">
                                    <div v-if="data.row.pay_type === '6'">
                                        {{data.row.pay_type_name}}
                                        <el-popover placement="top-start" width="200" trigger="hover">
                                            <i class="el-icon-info" slot="reference"></i>
                                            <div v-if="data.row.pay_data && data.row.pay_data.money !== '0'">余额：{{data.row.pay_data.money}}</div>
                                            <div v-if="data.row.pay_data && data.row.pay_data.wechat !== '0'">微信：{{data.row.pay_data.wechat}}</div>
                                            <div v-if="data.row.pay_data && data.row.pay_data.alipay !== '0'">支付宝：{{data.row.pay_data.alipay}}</div>
                                            <div v-if="data.row.pay_data && data.row.pay_data.cash !== '0'">现金：{{data.row.pay_data.cash}}</div>
                                            <div v-if="data.row.pay_data && data.row.pay_data.unionpay !== '0'">银联：{{data.row.pay_data.unionpay}}</div>
                                            <div v-if="data.row.pay_data && data.row.pay_data.arrears !== '0'">欠款：{{data.row.pay_data.arrears}}</div>
                                        </el-popover>
                                    </div>
                                    <div v-else>{{data.row.pay_type_name}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="before_money" label="消费前余额"></el-table-column>
                            <el-table-column prop="after_money" label="消费后余额"></el-table-column>
                            <!--<el-table-column prop="before_score" label="消费前积分"></el-table-column>-->
                            <!--<el-table-column prop="after_score" label="消费后积分"></el-table-column>-->
                            <el-table-column prop="staff_mobile" label="收银员">
                                <template slot-scope="data">
                                    <span v-if="data.row.staff_id && data.row.staff_id != '0'">{{data.row.staff_mobile}}</span>
                                    <span v-else>无</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="count-box flex">
                            <div style="width: 55px">&nbsp;</div>
                            <div style="width: 540px">
                                <div class="ceil">
                                    本页合计
                                </div>
                            </div>
                            <div class="flex-1">
                                <div class="ceil">
                                ¥{{pagePriceCount.page_total_price}}
                                </div>
                            </div>
                            <div class="flex-1">
                                <div class="ceil">
                                ¥{{pagePriceCount.page_actual_price}}
                                </div>
                            </div>
                            <div class="flex-4">&nbsp;</div>
                        </div>
                        <div class="count-box flex">
                        <div style="width: 55px">&nbsp;</div>
                        <div style="width: 540px">
                            <div class="ceil">
                                总共合计
                            </div>
                        </div>
                        <div class="flex-1">
                            <div class="ceil">
                                ¥{{allPriceCount.all_total_price}}
                            </div>
                        </div>
                        <div class="flex-1">
                            <div class="ceil">
                                ¥{{allPriceCount.all_actual_price}}
                            </div>
                        </div>
                        <div class="flex-4">&nbsp;</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper, slot"
                        :total="page.count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import RightTop from "@/model/RightTop";
    export default {
        name: "History",
        components: {RightTop, SearchBox, Menu},
        data: () => {
            // let time = new Date().getTime();
            // let startDate = obj.dateFtt("yyyy-MM-dd", new Date(time - 1 * 24 * 3600 * 1000));
            // let endDate = obj.dateFtt("yyyy-MM-dd", new Date(time));
            return {
                //搜索
                searchOrderNo: "",
                startDate: "",
                endDate: "",
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                payValue: "",
                payType: [
                    {
                        label: "余额",
                        value: "1"
                    }, {
                        label: "微信",
                        value: "2"
                    }, {
                        label: "支付宝",
                        value: "3"
                    }, {
                        label: "现金",
                        value: "4"
                    }, {
                        label: "银联卡",
                        value: "5"
                    }, {
                        label: "组合支付",
                        value: "6"
                    }
                ],

                //订单状态
                orderState: "",
                orderStateArr: [
                    {
                        label: "正常订单",
                        value: "4"
                    }, {
                        label: "作废订单",
                        value: "6"
                    }
                ],

                //订单类型
                orderType: "",
                orderTypeArr: [
                    {
                        label: "充值",
                        value: "2"
                    }
                ],

                //选择
                selectData: {},

                //分页
                page: {
                    nowPage: 1,
                    pageSize: 20,
                    pageSizes: [20, 50, 100],
                    count: 0,
                },
                tableData: [],
                loading: false,
                loadDom: null,

                //订单统计
                allPriceCount: {},
                pagePriceCount: {},
            };
        },
        mounted: function(){
            this.$store.commit("setMenuId", "2-2");
            this.loadListData();
        },
        methods: {
            //搜索事件
            searchEvent: function (data) {
                if(this.loading) return false;
                this.loading = true;

                this.page.nowPage = 1;
                this.loadListData();
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //加载列表数据
            ,loadListData: function () {
                let postData = {
                    order_type: this.orderType ? this.orderType : "",
                    start_date: this.startDate ? this.startDate : "",
                    end_date: this.endDate ? this.endDate : "",
                    pay_type: this.payValue ? this.payValue : "",
                    state: this.orderState ? this.orderState : "",
                    page: this.page.nowPage,
                    num: this.page.pageSize,
                    order_no: this.searchOrderNo,
                };
                obj.postData("cash/cash_history", postData, res => {
                    if(res.errcode === 0){
                        res.data.list_data.forEach(val => {
                            val.isChecked = false;
                        });
                        this.page.count = res.data.count;
                        this.tableData = res.data.list_data;
                        this.allPriceCount = res.data.all_price_count;
                        this.pagePriceCount = res.data.page_price_count;
                    }else{
                        this.tableData = [];
                    }
                    this.loading = false;
                }, res => {
                    this.loading = false;
                });
            }

            ,log: function (row) {
                obj.log(row);
            }

            //选中改变
            ,handleSelectionChange: function (item) {
                // if(!this.handleSelectable(item))
                //     return false;
                //
                // this.selectData = item;
                // this.tableData.forEach( val => {
                //     if (val.id !== item.id)
                //         val.isChecked = false;
                //     else
                //         val.isChecked = true;
                // });
            }

            //选择框点击
            ,checkedClick: function (item) {
                if(!this.handleSelectable(item))
                    return false;

                if(item.isChecked){
                    this.tableData.forEach( val => {
                        if (val.id !== item.id)
                            val.isChecked = false;
                    });
                    this.selectData = item;
                } else {
                    this.selectData = {};
                }
            }

            //判断是否可以选中
            ,handleSelectable: function (row) {
                if(row.state == 6) {
                    obj.message.error("不能选择已作废的订单");
                    return false;
                }else
                    return true;
            }

            //作废
            ,voidEvent: function () {
                if(obj.isEmpty(this.selectData)) {
                    obj.message.error("请先选择要作废的订单");
                    return ;
                }

                if(!this.handleSelectable(this.selectData)){
                    return ;
                }

                let orderId = this.selectData.id;
                obj.messageBox.confirm("确定要作废当前选中订单吗？", "提醒", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(this.loading) return false;
                    this.loading = true;

                    obj.postData("cash/void_order", {order_id: orderId}, res => {
                        if(res.errcode === 0){
                            obj.message.success("作废处理完成");
                            this.loadListData();
                        }else{
                            obj.message.error(res.errdesc);
                        }
                        this.loading = false;
                    });
                }, () => {

                });
            }
        },
        watch: {
            tableData: function (data) {
                // obj.unScrollbar(".el-table__body-wrapper");
                // this.$nextTick(() => {
                //     obj.scrollbar(".el-table__body-wrapper");
                // });
            },
            loading: function (val) {
                if(val){
                    this.loadDom = this.$loading({
                        lock: false,
                        // text: 'Loading',
                        // spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.3)',
                        target: ".container"
                    });
                }else{
                    this.loadDom.close();
                }
            }
        }
    }
</script>

<style scoped>
    .layout-right-body>.item-box{
        height: 72px;
        line-height: 72px;
        width: 100%;
    }
    .item-box>.item-search{
        padding: 0px 16px;
    }
    .layout-right-body>.item-content{
        width: 100%;
        overflow: hidden;
        background-color: #ffffff;
    }
    .layout-right-body>.item-content>.table-box{
        border-bottom: none;
        overflow: auto;
        padding: 0 0;
        margin: 5px 16px 0;
    }
    .table-box>.table-content{
        min-width: 1215px;
        overflow: hidden;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-top: 1px solid #ebedf0;
    }
    .layout-right-bottom{
        padding-top: 0px;
    }
    .order-data>p{
        padding: 0;
        margin: 0;
        line-height: 25px;
    }
    .select{
        width: 120px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 150px;
    }
    .flex-4{
        flex: 4;
    }
    .flex-6{
        flex: 6;
    }
    .count-box{
        min-width: 1215px;
        line-height: 23px;
        border-bottom: 1px solid #EBEEF5;
    }
    .count-box .ceil{
        padding: 10px;
        color: #606266;
    }
    .el-icon-info{
        color: #cccccc;
    }
</style>
